import { render, staticRenderFns } from "./JcomMenuPermissionList.vue?vue&type=template&id=9a3be564"
import script from "./JcomMenuPermissionList.vue?vue&type=script&lang=js"
export * from "./JcomMenuPermissionList.vue?vue&type=script&lang=js"
import style0 from "./JcomMenuPermissionList.vue?vue&type=style&index=0&id=9a3be564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports